import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule, createLazyComponent } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "GroupsReportAbuse" */ './lazyIndex'),
    { name: 'GroupsReportAbuse' }
);

export const lazyOpenGroupsReportAbuseForm: LazyAction<
    typeof lazyIndex.openGroupsReportAbuseFormMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.openGroupsReportAbuseFormMutator);

export const LazyGroupsReportAbuseDialogWrapper: typeof lazyIndex.GroupsReportAbuseDialogWrapper =
    createLazyComponent(lazyModule, m => m.GroupsReportAbuseDialogWrapper);
